import { history } from 'umi';

export const getAlineaCalibrationSourceMetrics = (metrics?: string[] | null): IRecord<string[]> => {
  const metricsNew = Array.isArray(metrics) ? metrics : [];

  return {
    alinea_calibration: metricsNew,
  };
};

/**
 * 转换任意类型值为number类型的值，如果Number转换为NaN，则返回0
 * @param num 指定数字，任意类型
 * @returns 指定数字的number类型的值
 */
const getNumberOrZero = (num: any): number => {
  const temp = Number(num);
  return Number.isNaN(temp) ? 0 : temp;
};

export const getNumberWidthDefaultValue = (num: any, defaultNum: number): number => {
  const numTemp = Number(num);
  const defaultNumTemp = Number(defaultNum);

  return Number.isNaN(numTemp) ? getNumberOrZero(defaultNumTemp) : numTemp;
};

export function isSafari() {
  const ua = navigator.userAgent.toLowerCase();
  return /safari/.test(ua) && !/chrome/.test(ua);
}

export const getDataSourceMetrics = (dataSourcesMetrics: any, metrics: any) => {
  if (!Array.isArray(dataSourcesMetrics)) return {};
  if (!Array.isArray(metrics)) return {};
  return dataSourcesMetrics.reduce((acc, cur) => {
    if (!cur) return acc;
    const { dataSource, metric } = cur;
    if (!dataSource || !metric) return acc;
    if (!metrics.includes(metric)) return acc;
    if (!acc[dataSource]) {
      acc[dataSource] = [];
    }
    acc[dataSource].push(metric);
    return acc;
  }, {});
};

export const getDownloadFileName = (pageType: string, fileName: string, entityType: string) => {
  if (fileName) {
    // 如果有传下载名称，直接用，否则再分文件名
    return fileName;
  }

  switch (pageType) {
    case 'mobile-activeuser':
      return 'Top Charts_Mobile Games_Active Users';
    case 'mobile-activeuser-studio':
      return 'Top Charts_Mobile Games_Active Users';
    case 'mobile-revenue':
      return 'Top Charts_Mobile Games_Revenue';
    case 'mobile-downloads':
      return 'Top Charts_Mobile Games_Downloads';
    case 'mobile-rpd':
      return 'Top Charts_Mobile Games_RPD';
    case 'mobile-retention':
      return 'Top Charts_Mobile Games_Retention';
    case 'mobile-demographics':
      return 'Top Charts_Mobile Games_Demographics';
    case 'mobile-databrain':
      return 'Top Charts_Mobile Games_DataBrain Calibration';

    case 'pc-MetricsTable':
      return 'Top Charts_PC Games_Metrics Table';
    case 'pc-PCU':
      return 'Top Charts_PC Games_PCU';
    case 'pc-DigitalRevenue':
      return 'Top Charts_PC Games_Digital Revenue';
    case 'pc-PhysicalRevenue':
      return 'Top Charts_PC Games_Physical Revenue';
    case 'pc-SteamSales':
      return 'Top Charts_PC Games_Steam Sales';
    case 'pc-MAU':
      return 'Top Charts_PC Games_MAU';
    case 'pc-LifeTimePlayers':
      return 'Top Charts_PC Games_Lifetime Players';

    case 'console-MetricsTable':
      return 'Top Charts_Console Games_Metrics Table';
    case 'console-DigitalRevenue':
      return 'Top Charts_Console Games_Digital Revenue';
    case 'console-PhysicalRevenue':
      return 'Top Charts_Console Games_Physical Revenue';
    case 'console-MAU':
      return 'Top Charts_Console Games_MAU';
    case 'console-LifeTimePlayers':
      return 'Top Charts_Console Games_Lifetime Players';

    case 'companies-revenue':
      return 'Top Charts_Companies_Revenue';
    case 'companies-downloads':
      return 'Top Charts_Companies_Downloads';
    case 'companies-mentions':
      return 'Top Charts_Companies_Mentions';

    case 'combine-PCConsoleMetricsTable':
    case 'combine-PCConsoleMetricsTable-studio':
    case 'pc-console-topCharts':
    case 'databrain-calibration-pc-console-topCharts':
      return 'Top Charts_PC Games & Console Games_Metrics Table';
    case 'topcharts-console-japan-sales':
      return 'Top Charts_Console Games_Japan Sales';

    case 'following-currentgame-mobile':
      return 'Following_Mobile Games_Current Games';
    case 'following-currentgame':
      return entityType === 'pc'
        ? 'Following_PC Games_Current Games'
        : 'Following_Console Games_Current Games';
    case 'following-newgame':
      if (entityType === 'pc') {
        return 'Following_PC Games_New Release & Upcoming Games';
      }
      if (entityType === 'console') {
        return 'Following_Console Games_New Release & Upcoming Games';
      }
      return 'Following_Mobile Games_New Release & Upcoming Games';
    case 'following-newcompany':
      return 'Following_Company_Current Games';

    case 'mobile-store-rank-more':
      return 'Store Ranks_Mobile Global/Region_Detail';
    case 'weixin-store-rank-more':
      return 'Mini-game Ranking WeChat_Detail';
    case 'pc-store-rank-more':
      return 'Store Ranks_PC Global_Detail';
    case 'console-store-rank-more':
      return 'Store Ranks_Console_Region_Detail';
    case 'genre-profile':
      if (entityType === 'pc') {
        return 'Genre Profile_PC Games';
      }
      if (entityType === 'console') {
        return 'Genre Profile_Console Games';
      }
      if (entityType === 'total') {
        return 'Genre Profile_Total Games';
      }
      return 'Genre Profile_Mobile Games';
    //  Compare
    case 'compare-mobile':
      if (entityType === 'pc') {
        return 'Compare_PC Games';
      }
      if (entityType === 'console') {
        return 'Compare_Console Games';
      }
      return 'Compare_Mobile Games';
    case 'compare-mobile-store-rank':
      return 'Compare_Store Rank';

    case 'streaming-anchors-more':
      return 'Streaming_Influencer';
    case 'streaming-games-top':
      return 'Streaming_Games';
    case 'marketProfile-stats':
      const countryName = history?.location?.query?.marketName;
      // 赵漫：具体名为国家
      return countryName;
    default:
      return fileName;
  }
};

// 是否有勾选steam数据源
export const ifHasSteam = (metriclist: string[]) => {
  if (Array.isArray(metriclist) && metriclist?.length > 0) {
    const steamList = ['hw', 'at', 'pk', 'ac'];
    return metriclist.findIndex((item: string) => steamList.some((it: string) => it == item)) > -1;
  }
  return false;
};

const sourceDownloadDevice: Record<string, string[]> = {
  npd: [
    'PC',
    'PlayStation 4',
    'PlayStation 5',
    'Xbox One',
    'Xbox Series X|S',
    'Nintendo Wii U',
    'Nintendo Switch',
  ],
  mscience: ['PC', 'PlayStation', 'Xbox', 'Nintendo'],
  famitsu: ['PS5', 'PS4', 'Switch'],
  newzoo: ['PC', 'PlayStation 4', 'PlayStation 5', 'Xbox One', 'Xbox Series X|S'],
  metacritic: ['PC', 'PS4', 'PS5', 'XOne', 'XS X|S', 'Wii U', 'NS'],
  gsd: [
    'PC',
    'PlayStation 4',
    'PlayStation 5',
    'Xbox One',
    'Xbox Series X|S',
    'WII U',
    'Nintendo Switch',
  ],
  ampere: ['PC', 'PlayStation', 'Xbox'],
};

// Countries 的 device 和 kpiTrends 页不同，暂时单独指定
const countriesAmpereSourceDownloadDevice: Record<string, string[]> = {
  ...sourceDownloadDevice,
  // ampere: ['PC', 'PlayStation 4', 'PlayStation 5', 'Xbox One', 'Xbox Series X|S'],
  ampere: ['Steam', 'PlayStation 4', 'PlayStation 5', 'Xbox One', 'Xbox Series'],
};

const DEVICETYPE: string[][] = [
  ['PC', 'Steam'],
  ['PlayStation 4', 'PlayStation 5', 'PlayStation', 'PS4', 'PS5'],
  [
    'Xbox One',
    'Xbox',
    'Xbox Series X|S',
    'XOne',
    'XS X|S',
    'Xbox One X',
    'Xbox Series X',
    'Xbox Series',
  ],
  ['Nintendo Wii U', 'Nintendo Switch', 'Switch', 'Nintendo', 'Wii U', 'WII U', 'NS'],
];

function findRelatedDevices(metriclist: string[]): string[] {
  const relatedDevices: string[] = [];
  metriclist.forEach((metric) => {
    DEVICETYPE.forEach((group) => {
      if (group.includes(metric)) {
        group.forEach((device) => {
          if (!relatedDevices.includes(device)) {
            relatedDevices.push(device);
          }
        });
      }
    });
  });
  return relatedDevices;
}

// 筛选同义device类型，应用于下载弹窗传参
export function commonFilterDevice(
  metriclist: string[],
  isCountries?: boolean,
): Record<string, string[]> {
  const relatedDevices = findRelatedDevices(metriclist);

  const filteredSource: Record<string, string[]> = {};

  const currentSourceDownloadDevice = isCountries
    ? countriesAmpereSourceDownloadDevice
    : sourceDownloadDevice;

  // eslint-disable-next-line no-restricted-syntax
  for (const key in currentSourceDownloadDevice) {
    filteredSource[key] = currentSourceDownloadDevice[key].filter((device) =>
      relatedDevices.includes(device),
    );
  }

  return filteredSource;
}

// 筛选segment类型，应用于下载弹窗传参
export function commonFilterSegment(
  currentMetric: string,
  segmentVal: string,
): Record<string, string[]> {
  const mapObj: Record<string, string> = {
    allMetrics: 'mscience',
    mscience: 'mscience',
    digitalRevenue: 'mscience',
    gsd: 'gsd',
  };
  const allValueMap: Record<string, string[]> = {
    mscience: [
      'Full Game',
      'DLC: All Other',
      'DLC: Expansion',
      'DLC: Content Pre-Purchase Pass',
      'DLC: Unlockable Content Pass',
      'MTX',
      'Subscription',
    ],
    gsd: ['Game', 'Add-On', 'In-Game Currency'],
  };
  const res: Record<string, string[]> = {
    npd: [],
    mscience: [],
    famitsu: [],
    newzoo: [],
    metacritic: [],
    gsd: [],
  };

  const key = mapObj?.[currentMetric];
  if (key === 'mscience') {
    res.gsd = allValueMap.gsd || [];
  }
  if (key === 'gsd') {
    res.mscience = allValueMap.mscience || [];
  }
  if (segmentVal === 'All' && res[key]) {
    res[key] = allValueMap?.[key];
  } else {
    res?.[key]?.push(segmentVal);
  }
  return res;
}
